import React from "react";
import Login from "./Login.js";
import { constants } from "../../../utils/Constants.js";
import SecurityService from "../../../services/SecurityService.js";
import UserService from "../../../services/UserService.js";

import CredentialsValidator from "../../../validators/CredentialsValidator";
import UserSession from "../../../session/UserSession.js";
import { paths } from "../../paths.js";
import RouteUtil from "../../../utils/RouteUtil";
import PageComponent from "../page/PageComponent/index.js";
import LocalizationUtil from "../../../localization/LocalizationUtil.js";
import { labels } from "../../../localization/labels.js";

const { REACT_APP_AUTHENTICATION_TYPE } = process.env;

const HttpStatus = require("http-status-codes");

class LoginContainer extends PageComponent {
  constructor(props) {
    super(props);

    this.authenticationType = REACT_APP_AUTHENTICATION_TYPE;

    this.securityService = new SecurityService();

    this.userService = new UserService();

    this.credentialsValidator = new CredentialsValidator();

    this.messageAlert = React.createRef();

    this.state = {
      username: "",
      password: "",
      isLoggedIn: UserSession.isUserLoggedIn()
    };

    this.receivedMessage = RouteUtil.getAndDeleteLocationParameter(
      props,
      "message"
    );
  }

  getComponentTitle = () => {
    return undefined;
  };

  onLogin = data => {
    UserSession.setUser(data);
    this.getOperationClassifications(data);
  };

  getOperationClassifications = user => {
    this.userService.getPartyClassificationsByOperation(
      user.partyId,
      this.onOperationClassificationsLoad,
      this.onError
    );
  };

  onOperationClassificationsLoad = data => {
    let user = UserSession.getUser();
    user.operationClassifications = data;
    UserSession.setUser(user);
    this.setState({ isLoggedIn: UserSession.isUserLoggedIn() });
  };

  onSuccess = message => {
    if (this.messageAlert && this.messageAlert.current) {
      this.messageAlert.current.showSuccessMessage(message);
    }
  };

  onError = error => {
    if (this.messageAlert && this.messageAlert.current) {
      this.messageAlert.current.showErrorMessage(error);
    }
  };

  validateForm = () => {
    return this.credentialsValidator.validate(
      this.state.username,
      this.state.password
    );
  };

  onChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  onSubmit = event => {
    event.preventDefault();

    const credentials = this.constructLoginCredentials();
    this.prepareCall(
      this.securityService.login(credentials, this.onLogin, this.onError)
    );
    this.performCalls();
  };

  constructLoginCredentials() {
    return {
      username: this.state.username,
      password: this.state.password,
      authenticationType: this.authenticationType
    };
  }

  componentDidUpdate() {
    this.skipLoginIfLoggedIn();

    const message = this.receivedMessage;
    if (message !== undefined) {
      if (message.status === HttpStatus.OK) {
        this.onSuccess(message);
      } else {
        this.onError(message);
      }
      this.receivedMessage = undefined;
    }
  }

  componentDidMount() {
    this.skipLoginIfLoggedIn();
  }

  redirectToRegister = event => {
    event.preventDefault();

    this.changePath(paths.REGISTER_PATH);
  };

  skipLoginIfLoggedIn = () => {
    if (this.state.isLoggedIn) {
      if (!LocalizationUtil.isLocalized(labels)) {
        window.location.reload();
      } else {
        this.changePath(paths.APPLICATION_PATH);
      }
    }
  };

  render() {
    return (
      <Login
        {...this.renderProps()}
        username={this.state.username}
        password={this.state.password}
        onSubmit={this.onSubmit}
        onRegisterClick={this.redirectToRegister}
        onChange={this.onChange}
        isValid={this.validateForm}
        alertRef={this.messageAlert}
      />
    );
  }
}

export default LoginContainer;
